import { render } from "./ConsultView.vue?vue&type=template&id=1ef86346&scoped=true"
import script from "./ConsultView.vue?vue&type=script&lang=js"
export * from "./ConsultView.vue?vue&type=script&lang=js"

import "./ConsultView.vue?vue&type=style&index=0&id=1ef86346&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef86346"]])

export default __exports__